import { Component, Inject, OnInit } from '@angular/core';
import { DocumentBuiltinFlagDict, DocumentFlag, DocumentStatus, DocumentStatusSystem, SalesDocumentType, SalesDocumentTypeDict, SalesDocument } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'icc-document-status-info-dialog',
    templateUrl: './document-status-info-dialog.component.html',
    styleUrls: ['./document-status-info-dialog.component.scss'],
})
export class DocumentStatusInfoDialogComponent {
    documentStatuses: DocumentStatus[] = [];
    get documentTypeName() {
        return this.translateService.instant(
            SalesDocumentTypeDict[this.data.document.salesDocumentTypeId]
        );
    }

    documentFlags: DocumentFlag[] = [];

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            statusSystem: DocumentStatusSystem;
        },
        private translateService: TranslateService,
        private dialogRef: DialogRef,
    ) {
        this.documentStatuses = this.data.statusSystem.statuses;
        this.loadFlags();
    }

    loadFlags() {
        this.documentFlags = [];

        [1,2].forEach(group => {
            const groupFlags = this.data.statusSystem.system.flagGroups[group];

            groupFlags.forEach(groupFlag => {
                if (DocumentBuiltinFlagDict[groupFlag.code]) {
                    this.documentFlags.push({
                        id: 0,
                        order: 0,
                        documentTypesIds: [this.data.document?.salesDocumentTypeId as SalesDocumentType],
                        resetAfterOrderAnnexation: true,
                        resetAfterQuotationCopying: true,
                        resetAfterQuotationModification: true,
                        code: groupFlag.code,
                        name: this.translateService.instant(DocumentBuiltinFlagDict[groupFlag.code]),
                        canBuyerActivate: false,
                        canBuyerDeactivate: false,
                        canSellerActivate: false,
                        canSellerDeactivate: false,
                        buyerSideVisibility: true,
                    });
                } else {
                    const flag = this.data.statusSystem.flags.find(el => el.code === groupFlag.code);
                    if (flag) {
                        this.documentFlags.push(flag);
                    }
                }
            });
        });
    }

    close() {
        this.dialogRef.close();
    }
}
